<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">ユーザー登録</h2>

      <p class="bold_label">名字</p>
      <input type="text" class="text_form" v-model="newUserDetail.lastName"/>
      <p class="bold_label">名前</p>
      <input type="text" class="text_form" v-model="newUserDetail.firstName"/>

      <h2 class="large_label">事務所登録</h2>
      <p class="bold_label">事務所名（フリーランスの方は「フリーランス」とご入力ください）</p>
      <input type="text" class="text_form" v-model="newOffice.name"/>
      <p class="bold_label">郵便番号（ハイフン無し）</p>
      <input type="text" class="text_form" v-model="postcode"/>
      <p class="bold_label">住所</p>
      <input type="text" class="text_form" v-model="newOffice.address"/>
      <p class="bold_label">電話番号</p>
      <input type="text" class="text_form" v-model="phoneNumber"/>

      <button @click="registerUserDetail()" class="active-rectangle_button">登録</button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import {mapGetters} from "vuex";
import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
import call_axios from '@/assets/js/functions/_core/call_axios';
import toast from '@/assets/js/functions/_core/toast';
import collection from '@/assets/js/functions/firebase/firestore/collection';
import store from "@/store";
import logging from "@/assets/js/functions/_core/logging";

export default {
  name: "RegistrationUserDetail",

  mixins: [toast, collection, call_axios, logging],

  data() {
    return {
      postcode: '',
      phoneNumber: '',
      newUserDetail: {
        office: null,
        softwares: null,
        skills: null,
        lastName: '',
        firstName: '',
      },
      newOffice: {
        owner: null,
        name: '',
        postcode: '',
        address: '',
        phoneNumber: '',
      },
    }
  },

  beforeCreate() {
    Object.assign(this, {COLLECTION_NAMES});
  },

  computed: {
    ...mapGetters({customClaim: 'auth/customClaim', uid: 'auth/uid'}),

    onlyNumberPostcode() {
      return this.postcode.replace(new RegExp('-', 'g'), '');
    },
    onlyNumberPhoneNumber() {
      return this.phoneNumber.replace(new RegExp('-', 'g'), '');
    },
  },

  async created() {
    if (this.customClaim.hasUserDetail) this.$router.push({name: 'RegisterUserSkill'});
  },

  methods: {
    isValidUserDetail() {
      if (!this.newUserDetail.lastName || !this.newUserDetail.firstName || !this.newOffice.name || !this.newOffice.address || !this.onlyNumberPhoneNumber) {
        this.showErrorMessage('未入力の項目があります');
        return false;
      }
      return true;
    },

    async registerUserDetail() {
      if (!this.isValidUserDetail()) return;

      this.newOffice.postcode = this.onlyNumberPostcode;
      this.newOffice.phoneNumber = this.onlyNumberPhoneNumber;

      const defaultParams = {
        isDeleted: false,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
      const userDetailParams = { ...defaultParams, ...this.newUserDetail };
      const officeParams = { ...defaultParams, ...this.newOffice };

      const userDetailPath = this.getDocRef(COLLECTION_NAMES.USER_DETAILS).doc(this.uid)
      const officePath = this.getDocRef(COLLECTION_NAMES.OFFICES).doc()

      await store.dispatch('cover/toggleLoadCover');

      const batch = firebase.firestore().batch();
      batch.set(userDetailPath, userDetailParams);
      officeParams.owner = this.getDocPath(COLLECTION_NAMES.USER_DETAILS, this.uid);
      batch.set(officePath, officeParams);
      await batch.commit().then(() => {
        this.showSuccessMessage('ユーザー情報を更新しました。');
        this.$router.push({name: 'RegisterUserSkill'});
      }).catch(error => {
        store.dispatch('cover/toggleLoadCover');
        this.logger(error, "アクションが失敗しました。", {params: {newUserDetail: userDetailParams, newOffice: officeParams}});
        throw error;
      });

      await store.dispatch('cover/toggleLoadCover');
    }
  },
}

</script>

<style lang="scss" scoped>
.contents_wrapper {
  > .contents {
    @include form-contents();
    align-items: center;

    > div {
      .large_label {
        margin-top: 2rem;
      }
    }
  }
}
</style>
